/**
 * All the possible action type that the form and the inner reducer can consume.
 */
export enum ActionTypes {
  Reset = 'RESET',
  Validate = 'VALIDATE',
  Change = 'CHANGE',
}

export default ActionTypes;
